import { HttpService } from './httpService';
import { formUrl } from './formUrls';

export class DataService {
  constructor(
    private httpService: HttpService,
    private apiBaseUrl: string,
    private csrfToken: string
  ) {}

  public submit(data: unknown, callback: (p: unknown) => void, errorCallback: (p: unknown) => void): void {
    this.postCore('/submit', data, callback, errorCallback);
  }

  public save(data: unknown, callback: (p: unknown) => void, errorCallback: (p: unknown) => void): void {
    this.postCore('/save', data, callback, errorCallback);
  }

  public debug(data: unknown, callback: (p: unknown) => void, errorCallback: (p: unknown) => void): void {
    this.postCore('/storedebugentry', data, callback, errorCallback);
  }

  private postCore(
    url: string,
    data: unknown,
    callback: (data: unknown) => void,
    errorCallback: (data: unknown) => void
  ): void {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json;charset=UTF-8',
    };

    if (this.csrfToken) {
      headers['X-Csrf-Token'] = this.csrfToken;
    }

    void this.httpService.post(formUrl(this.apiBaseUrl, url), headers, data, callback, errorCallback);
  }
}
